import ReportedPostsBrowser from "./ReportedPostsBrowser";
export default ReportedPostsBrowser;
